module.exports = __webpack_public_path__ + "img/pingjia@2x.7e5e373f.png";